module.exports = __webpack_public_path__ + "static/img/jx-ctcy.9e7f934.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jx/jx-ctcy.png
// module id = ag48
// module chunks = 0